
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlL as ObiOwnShipControlLElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-l.js';
 
 
 

 
 export const ObiOwnShipControlL = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-l',
   elementClass: ObiOwnShipControlLElement,
   events: {
     
   }
  });
 
 